import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { MdLockOpen } from 'react-icons/md';

import {
  Container,
  ModalContainer,
  ModalHeader,
  ModalFooter,
  ButtonModal,
} from './styles';

const ModalConfirmaReabertura = ({
  modalConfirma,
  setModalConfirma,
  enviaReabertura,
}) => {
  const [confirmLoading, setConfirmLoading] = useState(false);

  const handleOk = () => {
    enviaReabertura(true);
  };
  const handleCancel = () => {
    setModalConfirma(false);
  };

  return (
    <Container>
      <Modal
        visible={modalConfirma}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        cancelText="Conferir depois"
        centered
        footer={null}
        closable={null}
        width="480px"
      >
        <ModalContainer>
          <ModalHeader>
            <div className="iconModal">
              <span>
                <MdLockOpen size={30} />
              </span>
            </div>
            <h2>
              Confirmarção de <span>abertura de competência </span>
            </h2>
          </ModalHeader>
          <div className="ModalBody">
            <div>
              <span>ATENÇÃO!</span>
              <p>
                A reabertura de competência excluirá os registros pré-existentes
                para o período correspondente, deixando-a em aberto para novos
                envios. Deseja continuar?
              </p>
            </div>
          </div>
        </ModalContainer>

        <ModalFooter>
          <ButtonModal type="button" onClick={handleOk}>
            {confirmLoading ? ' Enviando...' : 'OK'}
          </ButtonModal>
          <ButtonModal type="button" cancel onClick={handleCancel}>
            Cancelar
          </ButtonModal>
        </ModalFooter>
      </Modal>
    </Container>
  );
};

ModalConfirmaReabertura.propTypes = {
  modalConfirma: PropTypes.bool,
  setModalConfirma: PropTypes.func,
  enviaReabertura: PropTypes.func.isRequired,
};

ModalConfirmaReabertura.defaultProps = {
  modalConfirma: null,
  setModalConfirma: null,
};

export default ModalConfirmaReabertura;
